import React from 'react';
import { responsiveFont, responsivePaddingHorizontal, responsivePaddingVertical, responsiveImageSize, HorizontalPadding} from '../../common/responsive.utils';
import useMediaQuery from '@mui/material/useMediaQuery';
import infoWeb from '../../../assets/icon/sitter/web/recuirt.svg';
import infoMobile from '../../../assets/icon/sitter/mobile/recuirt.svg';

const Content06BrowserComponent = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles();

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.screen_Web}>
                        <span style={styles.titleTxt_Web}>
                            선발절차
                        </span>
                        <div style={styles.imgDiv_Web}>
                            <img src={infoWeb} style={styles.backgroundImage_Web} alt="이미지" />
                        </div>

                    </div>
                </>
            ) : (
                <>
                    <div style={styles.screen_Mobile}>
                        <span style={styles.titleTxt_Mobile}>
                        선발절차
                    </span>

                    <img src={infoMobile} style={styles.backgroundImage_Mobile} alt="이미지" />      </div>
                </>
            )}
        </>
    );
}

const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: { backgroundColor: "white", display: "flex", flexDirection: "column", boxSizing: "border-box", paddingTop: responsivePaddingVertical(50, 90), paddingBottom: responsivePaddingVertical(50, 110), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },
    titleTxt_Web: { fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start", paddingLeft: HorizontalPadding(24, 88)},
    backgroundImage_Web: { width: responsiveImageSize(268,1560), height: 252, marginTop: "6.25vh", lineHeight: "140%" },
    imgDiv_Web: { display: "flex", justifyContent: "center", marginLeft: "4%", marginRight: "4%" },
    
    screen_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "white", display: "flex", flexDirection: "column", alignItems: "center", boxSizing: "border-box", paddingTop: responsivePaddingVertical(50, 90), paddingBottom: responsivePaddingVertical(50, 110), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88) },
    titleTxt_Mobile: { fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: -0.3, alignSelf: "flex-start" },
    backgroundImage_Mobile: { width: responsiveImageSize(268, 1560), height: 440, marginTop: "6.25vh", lineHeight: "140%" }
});

export default Content06BrowserComponent;
